import styled, { css } from 'styled-components';
import { Text, Box, Icon, IconSize } from '@bechtel/gds';

export const TextStyled = styled(Text).attrs({
  color: 'white',
})`
  ${({ theme }) => css`
    padding-top: ${theme.spacings[300]};
    padding-bottom: ${theme.spacings[100]};
    margin-left: ${theme.spacings[400]};
    @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
      margin-left: ${theme.spacings[100]};
    }
  `}
`;

export const PlanningDateWindowStyled = styled(Box).attrs({
  py: { sm: '200' },
  mt: { sm: '100' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.bechtel.red};
    border-radius: ${theme.radii[500]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  `}
`;

export const LockIconStyled = styled(Icon).attrs({
  size: IconSize.SMALL,
  iconStyle: 'solid',
  icon: 'lock',
})`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    padding-left: ${theme.spacings[100]};
    padding-right: ${theme.spacings[200]};
  `}
`;
